import axios from "../../../../../services/api";
import Axios, {AxiosResponse, CancelTokenSource} from "axios";
import {getEnv} from "../../../../../api";
import {PaginationParamProps} from "../../../../hooks";

export interface IAtendimentoRecusadoService {
    findAll: (
        params: PaginationParamProps,
        body: Record<string, any>,
        source?: {
            token: CancelTokenSource
        }
    ) => Promise<any>;
    delete: (id: {
        id: string | number
    }) => Promise<any>;

}

export const AtendimentoRecusadoService: IAtendimentoRecusadoService = {

    findAll: async (params, body = {}) => {
        try {
            // @ts-ignore
            const response: AxiosResponse = await axios.post(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/recusado`,
                body,
                {
                    params,
                }
            );
            return response.data;
        } catch (error: any) {
            if (Axios.isCancel(error)) {
                console.log("Requisição cancelada", error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },



    delete: async (id) => {
        try {
            // @ts-ignore
            const response = await axios.delete(
                `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/recusado/${id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    },

};
